export default "__VITE_ASSET__CzM9vn_l__"